import { ADEMONTE, DEMONTE, MONTE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import formatDate from '@/services/general/formatIsoDate';
import store from '@/store/store';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import booleanConverter from '@/services/import/General/booleanConverter';
import moment from 'moment';

export default function fillFaceWithData(face, faceReference) {
  face.code = faceReference.codeFace ?? '';

  if (faceReference.etatFace === 'Monté' || faceReference.etatFace === 'Monte') {
    face.etat = MONTE;
  } else if (faceReference.etatFace === 'Démonté' || faceReference.etatFace === 'Demonte') {
    face.etat = DEMONTE;
  } else if (faceReference.etatFace === 'A démonté') {
    face.etat = ADEMONTE;
  }
  if (faceReference.declarableMairieFace) {
    face.declarableEnMairie = booleanConverter(faceReference.declarableMairieFace);
  }
  if (faceReference.dateMontageFace) {
    const dateDefault = moment('31/12/1899', 'DD/MM/YYYY');
    let date = moment(faceReference.dateMontageFace, 'DD/MM/YYYY');
    if (dateDefault.isSame(date)) date = date.add(1, 'd');
    face.dateMontage = formatDate(date);
  } else face.dateMontage = null;
  face.dateDemontage = faceReference.dateDemontageFace ? formatDate(moment(faceReference.dateDemontageFace, 'DD/MM/YYYY')) : null;
  face.faceMotifNonComId = face.faceMotifNonComId ? store
    .getters['parametres/parametre'](PARAMETRES_KEYS.faceMotifNonCom).find((type) => {
      return type.libelle.toLowerCase().trim()
        === faceReference.motifNonCommercialisation.toLowerCase().trim();
    }).id : null;
  face.numLigne = faceReference.numLigne;
  return face;
}
